import Board from "./pages/Board";

export default function App() {
  return <Board />;
}